import { AccessToken, FormDataKeyValuePair, OAuthIntegration } from '@glueapp/graph-types';

export interface SlackIntegrationMetaData {
    team: {
        name: string;
        id: string;
    };
    enterprise?: {
        // Currently unused
        name: string;
        id: string;
    };
}

const slackAuthorizeUrl = 'https://slack.com/oauth/v2/authorize';
const slackAccessTokenUrl = 'https://slack.com/api/oauth.v2.access';
const slackScopes = 'app_mentions:read,channels:read,channels:history,chat:write,files:read,files:write,groups:read,im:read,mpim:read';

export const SlackIntegration: OAuthIntegration<
    AccessToken,
    { SLACK_CLIENT_ID: string; SLACK_CLIENT_SECRET: string },
    SlackIntegrationMetaData
> = {
    integrationType: 'oauth',
    getAccessTokenUrl(secrets): string {
        return slackAccessTokenUrl;
    },
    getAuthorizationUrl(oauthState, redirectUri, secrets): string {
        return `${slackAuthorizeUrl}?client_id=${secrets.SLACK_CLIENT_ID}&scope=${slackScopes}&state=${oauthState}&redirect_uri=${redirectUri}`;
    },
    getGrantTypeTokenFormData(queryParams, redirectUri, secrets): FormDataKeyValuePair[] {
        return [
            { key: 'client_id', value: secrets.SLACK_CLIENT_ID },
            { key: 'client_secret', value: secrets.SLACK_CLIENT_SECRET },
            { key: 'code', value: queryParams.code },
            { key: 'redirect_uri', value: redirectUri },
        ];
    },
    getRefreshTokenFormData(secrets): FormDataKeyValuePair[] {
        throw new Error('Slack does not support token refresh');
    },
    renderOptionLabel(metaData) {
        return metaData.team.name;
    },
    requiredSecrets: ['SLACK_CLIENT_ID', 'SLACK_CLIENT_SECRET'],
    resolveTokenAndMetaDataFromSuccessResponse(responseData) {
        return {
            tokens: { access_token: responseData.access_token },
            metaData: {
                team: responseData.team,
                enterprise: responseData.enterprise,
            },
            providerAccountId: responseData.team.id,
        };
    },
    getProviderAccountIdFromMetaData: metaData => metaData.team.id,
    provider: 'slack',
    allowedDomains: ['slack.com', 'files.slack.com'],
};
